import React, { useState, useEffect } from "react";
import * as api from "../api/api";
import RenderNestedServices from "../Components/RenderNestedServices";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useParams, Outlet } from "react-router-dom";
import Loading from "../Components/Loading";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import checkAuthorization from "../config/checkAuth";
import { useLanguage } from "../Components/Localization/LanguageContext";
import strings from "../Components/Localization/strings";
const serviceTemplate = {
  name: "",
  parentServiceId: null,
  validFrom: "2000-01-01 00:00:00",
  validTo: "2099-01-01 00:00:00",
  uamServiceId: null,
  teamsInherited: false,
  isBillable: false,
  isDefaultCallService: true,
  isDefaultOutboundCallService: false,
};

function AdminServices(props) {
  const { language } = useLanguage();
  const pageTitle = "AdminServices";
  const [servicesResponse, setServicesResponse] = useState([]);
  const [show, setShow] = useState(false);
  const [serviceCreationData, setserviceCreationData] =
    useState(serviceTemplate);
  const [validated, setValidated] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const params = useParams();
  const handleFetchServices = () => {
    setLoading(true);
    api.getAllServices().then((response) => {
      console.log(response.data.object);
      setLoading(false);
      console.log(response.data.object);
      setServicesResponse(response.data.object);
    });
  };

  const navigate = useNavigate();

  // SAMPLE ERRORS

  /*useEffect(() => {
    // Simulate an error by trying to access a property of undefined
    const someVariable = undefined;
    console.log(someVariable.property);
  }, []);

  /*
  useEffect(() => {
    const fetchData = async () => {
      // Simulate a failed API request by making a request to a non-existent endpoint
      await axios.get("https://api.example.com/nonexistent-endpoint");
    };

    fetchData();
  }, []);*/

  useEffect(() => {
    console.log("id is : ", params.id);
    console.log("retrieving service in admin services");
    console.log("fetching services");

    checkAuthorization("SERVICE").then((result) => {
      if (result) {
        handleFetchServices();
      } else {
        navigate("/unauthorized");
      }
    });
  }, []);

  const handleClose = () => {
    setShow(false);
  };
  const handleServiceChange = (event) => {
    // console.log(serviceCreationData)
    setserviceCreationData({
      ...serviceCreationData,
      name: event.target.value,
    });
  };

  function updateServices(services, targetId, newServiceObject) {
    const updatedServices = [];

    for (const service of services) {
      const updatedService = { ...service };

      // Check if the service's ID matches the target ID
      if (service.serviceId === targetId) {
        updatedService.subServices.push({
          ...newServiceObject,
          subServices: [],
        });
      } else {
        // Recursively update subServices
        updatedService.subServices = updateServices(
          service.subServices,
          targetId,
          newServiceObject
        );
      }

      updatedServices.push(updatedService);
    }

    return updatedServices;
  }

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      console.log("params id", params.id);
      const servicePayload = {
        ...serviceCreationData,
        parentServiceId: params.id != undefined ? params.id : null,
      };
      setserviceCreationData(servicePayload);
      api
        .insertService(servicePayload)
        .then((res) => {
          console.log("created");
          setserviceCreationData(serviceTemplate);
          setShow(false);
          // TODO: change all service state to new state with newly added service
          if (params.id) {
            //creating a sub service
            let targetParentId = parseInt(params.id);
            let newServices = updateServices(
              servicesResponse,
              targetParentId,
              res.data.object
            );
            setServicesResponse(newServices);
          } else {
            //creating a parent service
            setServicesResponse((prevState) => [
              ...prevState,
              { ...res.data.object, subServices: [] },
            ]);
          }
          // handleFetchServices();
        })
        .catch((error) => {
          console.log("error while creating the service");
        });
    }

    setValidated(true);
  };
  return (
    <div className="main-content-container">
      <div className="options-bar">
        <h5 className="options-bar__title">
          {strings[pageTitle][language].pageName}
        </h5>
        <button className="button-options-bar" onClick={() => setShow(true)}>
          {params.id
            ? strings[pageTitle][language].mainAddButtonSub
            : strings[pageTitle][language].mainAddButtonRoot}
        </button>
        {isLoading ? (
          <Loading />
        ) : (
          <div className="options-bar__list">
            {/* <ServicesList services =  {serviceList} / > */}
            <RenderNestedServices options={servicesResponse} />
          </div>
        )}
      </div>

      <Outlet
        context={{
          servicesResponse,
          setServicesResponse,
        }}
      />
      <Modal show={show} onHide={handleClose}>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>
              {strings[pageTitle][language].addModalTitle}{" "}
              {params.id
                ? strings[pageTitle][language].subService
                : strings[pageTitle][language].rootService}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3" controlId="validationCustom03">
              <Form.Label>
                {strings[pageTitle][language].serviceName}
              </Form.Label>
              <Form.Control
                type="text"
                placeholder={strings[pageTitle][language].serviceNameHint}
                required
                value={serviceCreationData.name}
                onChange={handleServiceChange}
              />
              <Form.Control.Feedback type="invalid">
                {strings[pageTitle][language].serviceNameError}
              </Form.Control.Feedback>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="light" onClick={handleClose}>
              {strings[pageTitle][language].cancel}
            </Button>
            <Button variant="primary" type="submit">
              {strings[pageTitle][language].add}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default AdminServices;
